import { Pin } from "lucide-react";

interface ConversationItemProps {
  name: string;
  role?: string;
  message?: string;
  time: string;
  active?: boolean;
  avatar?: string;
  isPinned?: boolean;
  onClick?: () => void;
}

export function ConversationItem({
  name,
  role,
  message,
  time,
  active,
  avatar,
  isPinned,
  onClick,
}: ConversationItemProps) {
  return (
    <div
      className={`px-3 py-[10px] rounded-xl bg-white  hover:bg-gray-100 cursor-pointer my-2 mx-1 ${
        active ? "bg-stone-300" : ""
      }`}
      onClick={onClick}
    >
      <div className="flex items-center space-x-3 space-y-1">
        <img
          src={
            avatar ||
            "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
          }
          alt={name}
          className="w-10 h-10 rounded-full"
        />
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-1">
              {isPinned && (
                <Pin className="w-4 h-4 text-blue-500 transform rotate-45" />
              )}
              <h3 className="text-sm font-medium text-gray-900 truncate">
                {name}
              </h3>
            </div>
            <span className="text-xs text-gray-500">{time}</span>
          </div>
          {role && <p className="text-xs text-gray-500 truncate">{role}</p>}
          {message && (
            <p className="text-sm text-gray-500 truncate mt-1">{message}</p>
          )}
        </div>
      </div>
    </div>
  );
}
